module.exports = __webpack_public_path__ + "img/video-course-list-logo.f9646e54.png";